import { ImageSourcePropType } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

export interface ValuePropositionFeature {
  id: string;
  title: string;
  description: string;
  icon: keyof typeof Ionicons.glyphMap;
  landmarkImage: ImageSourcePropType;
  screenshot: ImageSourcePropType;
  animationDelay: number;
}

// Use bundled photos to ensure consistent, offline-safe backgrounds.
// Note: keep at least 3 entries since features reference indices 0..2.
const heroImages: ImageSourcePropType[] = [
  require('../../assets/travel/travel-1.jpg'),
  require('../../assets/travel/travel-1.jpg'),
  require('../../assets/travel/travel-1.jpg'),
];

const featureScreenshots: Record<string, ImageSourcePropType> = {
  itineraries: heroImages[0],
  collaborate: heroImages[0],
  budget: heroImages[0],
  map: heroImages[0],
  'ai-companion': heroImages[0],
};

/**
 * Value proposition features to showcase on the onboarding screen
 * Each feature includes a landmark image, icon, and positioning for floating animation
 */
export const VALUE_PROPOSITION_FEATURES: ValuePropositionFeature[] = [
  {
    id: 'itineraries',
    title: 'Add itineraries to your trips',
    description: 'Plan your perfect day with detailed schedules',
    icon: 'calendar-outline',
    landmarkImage: heroImages[0],
    screenshot: featureScreenshots.itineraries,
    animationDelay: 0,
  },
  {
    id: 'collaborate',
    title: 'Collaborate with other travellers',
    description: 'Share plans and coordinate with your travel group',
    icon: 'people-outline',
    landmarkImage: heroImages[1],
    screenshot: featureScreenshots.collaborate,
    animationDelay: 100,
  },
  {
    id: 'budget',
    title: 'Track your budget',
    description: 'Stay on top of expenses and manage your travel spending',
    icon: 'wallet-outline',
    landmarkImage: heroImages[2],
    screenshot: featureScreenshots.budget,
    animationDelay: 200,
  },
  {
    id: 'map',
    title: 'Map your trips',
    description: 'Visualize your journey and discover nearby places',
    icon: 'map-outline',
    landmarkImage: heroImages[0],
    screenshot: featureScreenshots.map,
    animationDelay: 300,
  },
  {
    id: 'ai-companion',
    title: 'Plan with Premium AI',
    description: 'Premium AI plans trips, adapts live, and keeps you on track',
    icon: 'sparkles-outline',
    landmarkImage: heroImages[1],
    screenshot: featureScreenshots['ai-companion'],
    animationDelay: 400,
  },
];

/**
 * Hero background images for immersive hero section
 * These rotate/fade to create dynamic background
 */
export const HERO_IMAGES = heroImages;

/**
 * Additional landmark images for background decoration
 * These float around the edges of the screen
 */
export const DECORATIVE_LANDMARKS = [
  {
    id: 'eiffel',
    image: heroImages[0],
    position: { x: 0.05, y: 0.1 },
    size: 120,
  },
  {
    id: 'statue',
    image: heroImages[0],
    position: { x: 0.9, y: 0.25 },
    size: 100,
  },
  {
    id: 'taj',
    image: heroImages[0],
    position: { x: 0.85, y: 0.75 },
    size: 110,
  },
];

